import Icon from "components/Elements/Icon/Icon";
import PickerPromoSidebarModal from "../../PickerPromo/Modals/PickerPromoSidebarModal";
import Button, { ButtonAccessability } from "components/Elements/Button/Button";
import useHasAvailableProjects from "../../PickerPromo/hooks/useHasAvailableProjects";
import Login from "components/Structure/Login/Login";
import PickerPromoFreeModal from "../../PickerPromo/Modals/PickerPromoFreeModal";
import PickerPromoLimitProjectsModal from "../../PickerPromo/Modals/PickerPromoLimitProjectsModal";
import { ISideBarPromoParams } from "./models";
import { useContent } from "contexts/contentContext/contentContext";
import { LinkToNewTab } from "components/Elements/Link/Link";
import { useModal } from "contexts/modalContext/modalContext";

import styles from "./sibeBarPromo.module.scss";

const SideBarPickerPromo = ({ setClosed, collapsed }: ISideBarPromoParams) => {
  const { getTextByKey, getDirection } = useContent();
  const { setModal } = useModal();

  const { anonimus, notSubscriber, fetched, available } =
    useHasAvailableProjects();

  const handleClose = (e: MouseEvent) => {
    e.stopPropagation();
    setClosed(true);
  };

  const handleClick = () => {
    if (anonimus) {
      setModal({
        modal: Login,
        modalSize: "full-modal",
      });
      return;
    }

    if (notSubscriber) {
      setModal({
        modal: PickerPromoFreeModal,
      });
      return;
    }

    if (!available) {
      setModal({
        modal: PickerPromoLimitProjectsModal,
        modalSize: "full-modal",
      });
      return;
    }

    setModal({
      modal: PickerPromoSidebarModal,
    });
  };

  return (
    <button
      className={
        styles.container +
        " " +
        styles.picker +
        (getDirection() === "rtl" ? ` ${styles.rtl}` : "") +
        (collapsed ? ` ${styles.collapsed}` : "")
      }
      type="button"
    >
      {/* @ts-ignore */}
      <ButtonAccessability onClick={handleClose} className={styles.closeButton}>
        <Icon name="x" gray />
      </ButtonAccessability>
      <div className={styles.iconContainer}>
        <Icon name="mega-menu/picker" />
      </div>
      <div className={styles.textContainer}>
        <h4>
          {getTextByKey("jumbopicker")}
          <LinkToNewTab page="jumbo-picker" isNewTab>
            {getTextByKey("learn-more")}
          </LinkToNewTab>
        </h4>
        <span>{getTextByKey("picker-sidebar-promo-text")}</span>
      </div>
      <div className="flex-spacer" />
      <Button
        onClick={handleClick}
        className={styles.pickerButton}
        disabled={!fetched}
      >
        {getTextByKey("create")}
      </Button>
    </button>
  );
};

export default SideBarPickerPromo;
